import { Typography, Box } from '@mui/material';
import Steps from './Steps';

const GettingStarted = () => {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        For å komme i gang med fotballyst kan du følge stegene nedenfor 👇
      </Typography>
      <Box mt={2}>
        <Steps />
      </Box>
    </div>
  );
};

export default GettingStarted;
